import { QueryClient } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import type { Frame } from "@/types/dragon-tiles";

import { frameQueryOptions } from "@/api/dragon-tiles";
import FrameManager from "@/features/FrameManager/FrameManager";

type FrameRouteLoaderData = {
  frame: Frame;
  siteId: string;
};

export const Route = createFileRoute(
  "/_auth/dragon-tiles/$siteId/$parentTile/tile/$frameId",
)({
  component: RouteComponent,
  loader: async ({ params, context }): Promise<FrameRouteLoaderData> => {
    const { queryClient } = context as { queryClient: QueryClient };
    const { siteId, frameId } = params;

    // Fetch the tile directly
    const frame = await queryClient.fetchQuery(
      frameQueryOptions(siteId, frameId),
    );

    if (!frame) {
      throw new Error("Tile not found");
    }

    return { frame, siteId };
  },
});

function RouteComponent() {
  const { frame, siteId } = Route.useLoaderData();
  const { parentTile } = Route.useParams();

  // Add null checks to ensure we have all required data
  if (!frame || !siteId) {
    throw new Error("Required data not found");
  }

  return <FrameManager siteId={siteId} parentTileId={parentTile} />;
}
